import { z } from 'zod';
import { whiteLabelServiceCorn } from '../base.js';
import { OwnerAssetsSchema } from './asset.js';
import { OwnerAuth0Schema } from './auth0.js';
import { OwnerDomainsSchema } from './domain.js';
import { OwnerEmailEnvelopeSchema, OwnerEmailSubjectsSchema, OwnerFooterSchema } from './email.js';
import { OwnerIdentitySchema } from './identity.js';
import { OwnerOptionsSchema } from './options.js';
import { OwnerThemeSchema } from './theme.js';
/** What gets merged into every MJML render */
export const OwnerBrandSchema = z.object({
    assets: OwnerAssetsSchema,
    domains: OwnerDomainsSchema,
    emailEnvelope: OwnerEmailEnvelopeSchema,
    emailSubjects: OwnerEmailSubjectsSchema,
    footer: OwnerFooterSchema,
    identity: OwnerIdentitySchema,
    theme: OwnerThemeSchema,
});
export const OwnerCornSchema = whiteLabelServiceCorn('owner');
export const OwnerStatusSchema = z.enum(['active', 'inactive']);
export const OwnerSchema = z.object({
    auth0: OwnerAuth0Schema,
    brand: OwnerBrandSchema,
    displayName: z.string().min(1), // "Evans Claims / EIG"
    id: OwnerCornSchema,
    options: OwnerOptionsSchema.optional(),
    status: OwnerStatusSchema,
});
